export default class WeirdApiResponseError extends Error{}